/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "sign-out-inline-0f745480--sprite",
  "use": "sign-out-inline-0f745480--sprite-usage",
  "viewBox": "0 0 13.615 14.92",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13.615 14.92\" id=\"sign-out-inline-0f745480--sprite\"><g transform=\"translate(1 1)\"><g transform=\"translate(5.168 3.876)\"><line x1=\"6.029\" transform=\"translate(0 2.584)\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"2\" /><line y1=\"2.584\" x2=\"2.584\" transform=\"translate(3.449 2.584)\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"2\" /><line x1=\"2.583\" y1=\"2.584\" transform=\"translate(3.45)\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"2\" /></g><path d=\"M471.168,643.167v-1.723a.862.862,0,0,0-.861-.861h-3.445a.862.862,0,0,0-.861.861v11.2a.861.861,0,0,0,.861.861h3.445a.861.861,0,0,0,.861-.861v-1.723\" transform=\"translate(-466 -640.583)\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"2\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
